import React from "react";
import "./MainHome.scss";
import { useNavigate } from 'react-router-dom';

import sortieChiens from "../../assets/img/sortie-chiens.png";
import gardeAnimaux from "../../assets/img/garde-animaux.png";
import visiteAnimaux from "../../assets/img/visite-animaux.png";
import coachingAnimaux from "../../assets/img/coaching-animaux.png";
import FAQ from "../faq/FAQ";

function MainHome() {

  const navigate = useNavigate();

  return (
    <main className="main-home">
      <section className="services">
        <h2 className="services__title">Mes services</h2>
        <div className="contain-card">
          <div className="card coach-canin-card">
            <h3 className="card__title">Coach en éducation canine</h3>
            <p className="card__text">
              Je vous propose des séances d'éducation canine pour vous aider à éduquer votre chien et à renforcer votre complicité.
            </p>
            <button className="card__button-services" onClick={() => navigate('/services', { state: { service: 'education' } })}>En savoir plus</button>
          </div>
          <div className="card pet-sitter-home-card">
            <h3 className="card__title">Pet-sitter à domicile</h3>
            <p className="card__text">
              Je vous propose de garder vos animaux à mon domicile.
            </p>
            <button className="card__button-services" onClick={() => navigate('/services', { state: { service: 'petsitter' } })}>En savoir plus</button>
          </div>
          <div className="card pet-sitter-out-card">
            <h3 className="card__title">Visites à domicile</h3>
            <p className="card__text">
              Je vous propose de rendre visite à vos animaux à votre domicile.
            </p>
            <button className="card__button-services" onClick={() => navigate('/services', { state: { service: 'visite' } })}>En savoir plus</button>
          </div>
          <div className="card promenade-card">
            <h3 className="card__title">Promenades</h3>
            <p className="card__text">
              Je vous propose de promener vos animaux.
            </p>
            <button className="card__button-services" onClick={() => navigate('/services', { state: { service: 'promenade' } })}>En savoir plus</button>
          </div>
        </div>
      </section>

      <section className="why">
        <h2 className="why__title">Pourquoi faire appel à mes services ?</h2>
        <div className="why__content">
          <div className="why__block">
            <img className="why__img" src={coachingAnimaux} alt="Coaching d'animaux" />
            <h3 className="why__heading">Coach en Éducation Canine</h3>
            <p className="why__text">Des séances d'éducation canine personnalisées pour <span style={{fontWeight: "bold"}}>renforcer la complicité</span> entre vous et votre chien. Techniques de dressage professionnelles pour un <span style={{fontWeight: "bold"}}>comportement équilibré</span> et une <span style={{fontWeight: "bold"}}>obéissance fiable</span>, adaptées à chaque duo maître-chien.</p>
          </div>
          <div className="why__block">
            <img className="why__img" src={gardeAnimaux} alt="Garde d'animaux" />
            <h3 className="why__heading">Garde d'Animaux à Domicile</h3>
            <p className="why__text">Dans un environnement familier et <span style={{fontWeight: "bold"}}>sécurisant</span>, les animaux bénéficient d'une <span style={{fontWeight: "bold"}}>attention personnalisée</span>, de la <span style={{fontWeight: "bold"}}>socialisation</span> avec d'autres animaux, de la conservation de leur routine, et de <span style={{fontWeight: "bold"}}>sorties</span> dans des parcs à chiens pour le plaisir et l'exercice.</p>
          </div>
          <div className="why__block">
            <img className="why__img" src={visiteAnimaux} alt="Visite d'animaux" />
            <h3 className="why__heading">Visites à Domicile</h3>
            <p className="why__text">Mes visites garantissent le <span style={{fontWeight: "bold"}}>bien-être</span> de vos animaux. Je m'occupe de leur alimentation, de la <span style={{fontWeight: "bold"}}>maintenance de leur espace de vie</span>, et je leur offre <span style={{fontWeight: "bold"}}>interaction et jeu pour réduire la solitude et l'ennui</span>.</p>
          </div>
          <div className="why__block">
            <img className="why__img" src={sortieChiens} alt="Sortie de chiens" />
            <h3 className="why__heading">Promenades d'Animaux</h3>
            <p className="why__text">Je propose des promenades pour l'<span style={{fontWeight: "bold"}}>exercice physique</span>, la <span style={{fontWeight: "bold"}}>stimulation mentale</span>, la <span style={{fontWeight: "bold"}}>socialisation</span> avec d'autres chiens, et la flexibilité des horaires pour s'adapter à votre emploi du temps. La <span style={{fontWeight: "bold"}}>sécurité</span> et le <span style={{fontWeight: "bold"}}>bien-être</span> de vos animaux sont toujours prioritaires.</p>
          </div>
        </div>
      </section>

      <FAQ />

    </main>
  );
}

export default MainHome;
